import { Routes, RouterModule } from '@angular/router';
import { CheckTransactionStatusComponent } from './shared/check-transaction-status/check-transaction-status.component';
import { RedirectComponent } from './shared/redirect/redirect.component';
import { SuccessComponent } from './shared/success/success.component';
import { VerificationComponent } from './shared/verification/verification.component';
import { SupportComponent } from './support/support.component';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule),
    pathMatch:'full'
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'home/:id',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'home/:id/:params',
    loadChildren: () => import('./home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'create-request',
    loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  },
  {
    path: 'create-request/:id',
    loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  },
  {
    path: 'create-request/:id/:params',
    loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  },
  
  {
    path: 'create-request/step1',
    loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  },
  {
    path: 'create-request/step2',
    loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  },
  
  {
    path: 'create-request/personalInfo',
    loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  },
  {
    path: 'create-request/requestDetail',
    loadChildren: () => import('./create-request/create-request.module').then(m => m.CreateRequestModule)
  },
  
  {
    path: 'track-request',
    loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  },
  {
    path: 'track-request/:id',
    loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  },
  
  {
    path: 'track-request/:id/:params',
    loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  },
  {
    path: 'track-request/detail',
    loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  },
  {
    path: 'track-request/search',
    loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  },
  {
    path: 'track-request/payment',
    loadChildren: () => import('./track-request/track-request.module').then(m => m.TrackRequestModule)
  },
  {
    path: 'approve-quotation-letter',
    loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  },
  {
    path: 'approve-quotation-letter/:id',
    loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  },
  
  {
    path: 'approve-quotation-letter/:id/:params',
    loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  },
  {
    path: 'approve-quotation-letter/step1',
    loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  },
  {
    path: 'approve-quotation-letter/step2',
    loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  },
  
  {
    path: 'approve-quotation-letter/step3',
    loadChildren: () => import('./approve-quotation-letter/approve-quotation-letter.module').then(m => m.ApproveQuotationLetterModule)
  },
  {
    path: 'verification',
    component: VerificationComponent
  },
  {
    path: 'success',
    component: SuccessComponent
  },
  {
    path: 'success/:params',
    component: SuccessComponent
  },
  {
    path: 'cqt-payment-success',
    component: SuccessComponent
  },
  {
    path: 'cqt-payment-success/:params',
    component: SuccessComponent
  },
  {
    path: 'redirect-page',
    component: RedirectComponent
  },
  {
    path: 'checkTransactionStatus',
    component: CheckTransactionStatusComponent
  },
  {
    path: 'support',
    component: SupportComponent
  },
  {path: '**', redirectTo: '/home'}
];

export const AppRoutes = RouterModule.forRoot(routes);
